import { PageContent } from "../../pages/templates/PageLayout";

const content: PageContent = {
  style: "lightGradient",
  sections: [
    {
      type: "FormSection",
      title: "Take Lingo for a spin",
      subtitle:
        "Please provide your contact information and we'll get you set up with a free, fully featured 30 day trial.",
      badge: "Request a free trial",
      form: "trial",
      position: { mb: "none", pb: "xxxl" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xl" } },
    { type: "TestimonialSection" },
    {
      type: "CtaSection",
      title: "Build your first kit in 5 minutes or less",
      body: "Organize, store, find, and share your brand assets in one library, from anywhere.",
    },
  ],
};

export default content;
